import { QueryClient } from '@tanstack/react-query'

// @ts-ignore
export const queryClient = new QueryClient({ defaultOptions: { timeout: 10000 } })
